(function () {
window.document_row = {
    init: function() {
        var _this = this;
        document.querySelectorAll('.documentation, .downloads_box, .download, .browse-product__documents__tables').forEach(function(section) {
            _this.makeIconsWork(section);
            _this.handleRowLanguageSelect(section);
        });
    },
    handleRowLanguageSelect: function(section) {
        var _this = this;
        this.updateExternalIcons(section);
        section.querySelectorAll('.document_row__language').forEach(function(language_select) {
            _this.handleSelect(language_select, section);
            _this.handleLanguageHover(language_select);
            language_select.querySelectorAll('.document_row__language__options__single').forEach(function(label) {
                _this.updateSelectLabel(language_select, label);
            });
            language_select.querySelectorAll('.document_row__language__options__single').forEach(function(label) {
                label.addEventListener('click', function(event) {
                    var all_option = label.querySelector('input[name^="all-options"]');
                    if (all_option) {
                        if (all_option.checked) language_select.querySelectorAll('input[name^="document-language"]').forEach(function(option) {
                            option.checked = true;
                        });
                        else language_select.querySelectorAll('input[name^="document-language"]').forEach(function(option) {
                            option.checked = false;
                        });
                    }
                    _this.updateSelectLabel(language_select, label);
                });
            });
        });
    },
    updateExternalIcons: function(section) {
        section.querySelectorAll('.document_row__language').forEach(function(language_select) {
            language_select.querySelectorAll('.document_row__language__options__single').forEach(function(label) {
                var box = language_select.parentElement.querySelector('.document_row__icons__single--box');
                var download = language_select.parentElement.querySelector('.document_row__icons__single--download');
                var checked_externals = language_select.querySelectorAll('.document_row__language__options__single.external input:checked');
                if (checked_externals.length) {
                    box === null || box === void 0 ? void 0 : box.classList.add('external-disabled');
                    download === null || download === void 0 ? void 0 : download.classList.add('external-disabled');
                } else {
                    box === null || box === void 0 ? void 0 : box.classList.remove('external-disabled');
                    download === null || download === void 0 ? void 0 : download.classList.remove('external-disabled');
                }
                label.addEventListener('click', function() {
                    var checked_externals = language_select.querySelectorAll('.document_row__language__options__single.external input:checked');
                    if (checked_externals.length) {
                        box === null || box === void 0 ? void 0 : box.classList.add('external-disabled');
                        download === null || download === void 0 ? void 0 : download.classList.add('external-disabled');
                    } else {
                        box === null || box === void 0 ? void 0 : box.classList.remove('external-disabled');
                        download === null || download === void 0 ? void 0 : download.classList.remove('external-disabled');
                    }
                });
            });
        });
    },
    updateSelectLabel: function(language_select, label) {
        var languages = language_select.querySelectorAll('.document_row__language__options__single:has(input[name^="document-language"]:checked)');
        var html = '';
        language_select.classList.remove('one-language');
        language_select.classList.remove('multiple-languages');
        if (languages.length === 0) html = 'Language';
        else if (languages.length === 1) {
            language_select.classList.add('one-language');
            html = languages[0].querySelector('span').innerHTML;
        } else {
            language_select.classList.add('multiple-languages');
            languages.forEach(function(lang) {
                var _lang_querySelector;
                html += (_lang_querySelector = lang.querySelector('span svg')) === null || _lang_querySelector === void 0 ? void 0 : _lang_querySelector.outerHTML;
            });
        }
        language_select.querySelector('.document_row__language__label_wrapper__label p').innerHTML = html;
    },
    handleLanguageHover: function(language_select) {
        language_select.querySelectorAll('.document_row__language__label_wrapper').forEach(function(label) {
            label.addEventListener('mouseleave', function(e) {
                label.querySelector('.hover').classList.remove('active');
            });
            label.addEventListener('mouseover', function(e) {
                var checked_count = 0;
                var checked_options = language_select.querySelectorAll('input[name^="document-language"]:checked');
                if (checked_options) checked_count = checked_options.length;
                if (checked_count == 0) return;
                label.querySelector('.hover').classList.add('active');
            });
        });
    },
    makeIconsWork: function(section) {
        var _this = this;
        section.querySelectorAll('.document_row').forEach(function(row) {
            _this.updateIcons(row);
            row.querySelectorAll('.document_row__language__options__single').forEach(function(option) {
                option.addEventListener('click', function() {
                    _this.updateIcons(row);
                });
            });
        });
    },
    updateIcons: function(row) {
        var eye = row.querySelector('.document_row__icons__single--eye');
        var download = row.querySelector('.document_row__icons__single--download');
        var box = row.querySelector('.document_row__icons__single--box');
        var active_languages = row.querySelectorAll('[name^="document-language"]:checked');
        var length = 0;
        if (active_languages) length = active_languages.length;
        eye === null || eye === void 0 ? void 0 : eye.classList.add('disabled');
        eye === null || eye === void 0 ? void 0 : eye.querySelector('.hover').classList.remove('active');
        download === null || download === void 0 ? void 0 : download.classList.add('multiple');
        download === null || download === void 0 ? void 0 : download.removeAttribute('download');
        download === null || download === void 0 ? void 0 : download.removeAttribute('href');
        if (length === 1) {
            eye === null || eye === void 0 ? void 0 : eye.classList.remove('disabled');
            eye === null || eye === void 0 ? void 0 : eye.setAttribute('href', active_languages[0].getAttribute('data-url'));
            download.classList.remove('multiple');
            download.setAttribute('download', '');
            download.setAttribute('href', active_languages[0].getAttribute('data-url'));
        }
        eye === null || eye === void 0 ? void 0 : eye.addEventListener('mouseleave', function(e) {
            eye.querySelector('.hover').classList.remove('active');
        });
        eye === null || eye === void 0 ? void 0 : eye.addEventListener('mouseover', function(e) {
            if (!eye.classList.contains('disabled')) return;
            eye.querySelector('.hover').classList.add('active');
        });
        if (box) {
            box.addEventListener('mouseleave', function(e) {
                var hover_class = '.hover';
                if (box.classList.contains('external-disabled')) hover_class = '.external-hover';
                box.querySelector(hover_class).classList.remove('active');
            });
            box.addEventListener('mouseover', function(e) {
                var hover_class = '.hover';
                if (box.classList.contains('external-disabled')) hover_class = '.external-hover';
                box.querySelector(hover_class).classList.add('active');
            });
        }
        if (download) {
            download.addEventListener('mouseleave', function(e) {
                if (!download.classList.contains('external-disabled')) return;
                download.querySelector('.external-hover').classList.remove('active');
            });
            download.addEventListener('mouseover', function(e) {
                if (!download.classList.contains('external-disabled')) return;
                download.querySelector('.external-hover').classList.add('active');
            });
            download.addEventListener('click', function(e) {
                //we don't want the href url to download
                if (download.classList.contains('multiple') || download.classList.contains('external-disabled')) e.preventDefault();
                //we don't want the zips to download
                if (download.classList.contains('external-disabled') || !download.classList.contains('multiple')) return;
                var attachments = [];
                var selected_languages = row.querySelectorAll('[name^="document-language"]:checked');
                if (selected_languages.length === 0) {
                    var all_languages = row.querySelectorAll('[name^="document-language"]');
                    all_languages.forEach(function(attachment) {
                        attachments.push(attachment.value);
                    });
                } else selected_languages.forEach(function(language) {
                    attachments.push(language.value);
                });
                window.open("".concat(document_row_php.documents_endpoint, "?selected_documents=").concat(attachments.join(',')));
            });
        }
    },
    handleSelect: function(element, section) {
        if (!element) return;
        element.addEventListener('click', function(e) {
            e.stopImmediatePropagation();
            if (element.classList.contains('active')) {
                element.classList.remove('active');
                return;
            }
            section.querySelectorAll('.documentation__header__filters__single').forEach(function(filter) {
                filter.classList.remove('active');
            });
            section.querySelectorAll('.document_row__language').forEach(function(language_select) {
                language_select.classList.remove('active');
            });
            element.classList.toggle('active');
        });
        document.addEventListener('click', function(event) {
            if (!element.contains(event.target)) element.classList.remove('active');
        });
    }
};
if (document.readyState !== 'loading') window.document_row.init();
else document.addEventListener('DOMContentLoaded', function() {
    window.document_row.init();
});

})();
//# sourceMappingURL=_document_row.js.map
